import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../styles/ChapterLectures.css";
import mlogo from "../assets/ntmlogo.jpg"; // ✅ Import logo

const ChapterLectures10 = () => {
  const { subject, chapterIndex } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [navigate]);

  const chapterLectures = {
    Maths: {
      0: [
  {
    "name": "Abhay Batch 10th Maths - 1st FREE Class | Real Numbers - Lecture 1",
    "youtubeUrl": "https://www.youtube.com/live/NRC-wPWLBlE?si=NARMsCHU3nX2oy4T"
  },
  {
    "name": "Polynomials",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4251483/173376362999381815381/173376362999381815381_1815381.m3u8"
  },
  {
    "name": "Pair of linear Equation in Two Variables",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4252416/173384903812598296383/173384903812598296383_8296383.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4255377/173409684958091097666/173409684958091097666_1097666.m3u8"
  },
  {
    "name": "Quadratic Equations Complete",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4256065/173418347822961097666/173418347822961097666_1097666.m3u8"
  },
  {
    "name": "Arthemetric Progression Lecture ~ 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4261095/173436845496528296383/173436845496528296383_8296383.m3u8"
  },
  {
    "name": "Arthemetric Progression Lecture ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4264780/173470208639291097666/173470208639291097666_1097666.m3u8"
  },
  {
    "name": "Triangles L1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4265471/173478728962341097666/173478728962341097666_1097666.m3u8"
  },
  {
    "name": "Triangles L2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4266460/173497383884211097666/173497383884211097666_1097666.m3u8"
  },
  {
    "name": "Triangles L3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4267283/173505946379421097666/173505946379421097666_1097666.m3u8"
  },
  {
    "name": "Trigonometry 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4269522/173530593670251097666/173530593670251097666_1097666.m3u8"
  },
  {
    "name": "Trigonometry 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4270881/173557927351208296383/173557927351208296383_8296383.m3u8"
  },
  {
    "name": "Coordinate Geo Complete",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4271555/173566254832118296383/173566254832118296383_8296383.m3u8"
  },
  {
    "name": "Coordinate Geo Complete + Doubt Solving",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4273558/173591079538391097666/173591079538391097666_1097666.m3u8"
  },
  {
    "name": "Circle ~ 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4275218/173618267231918296383/173618267231918296383_8296383.m3u8"
  },
  {
    "name": "Circle ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4276282/173626901232738296383/173626901232738296383_8296383.m3u8"
  },
  {
    "name": "Area Rel to Circles Complete",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4278934/173651542956061097666/173651542956061097666_1097666.m3u8"
  },
  {
    "name": "Doubt Solving Class 10th",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4279689/173660100838151097666/173660100838151097666_1097666.m3u8"
  },
  {
    "name": "Surface Area And Volume",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4281322/173687534281188296383/173687534281188296383_8296383.m3u8"
  },
  {
    "name": "Statistics",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4282142/173696092067378296383/173696092067378296383_8296383.m3u8"
  },
  {
    "name": "Probability Complete",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4283192/173704645359348296383/173704645359348296383_8296383.m3u8"
  },
  {
    "name": "Sample Paper Discussion 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4284288/173712790984178296383/173712790984178296383_8296383.m3u8"
  },
  {
    "name": "Sample Paper 2 and 3 discussion",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4286104/173739037329958296383/173739037329958296383_8296383.m3u8"
  }
],
      1:[
  {
    "name": "DPP - Abhay 2025 DPP 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/702970420779209200.pdf"
  },
  {
    "name": "DPP 2 (Application of Trigonometry)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/479537168714873700.pdf"
  },
  {
    "name": "Real Numbers Notes ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/889895775705671700.pdf"
  },
  {
    "name": "Polynomials Notes",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/584289696854248600.pdf"
  },
  {
    "name": "Pair of liner EQ in 2 Variable Notes",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/522721703897091600.pdf"
  },
  {
    "name": "Quadratic Equations ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/559155855708955400.pdf"
  },
  {
    "name": "Quadratic Equations",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/561709171043682300.pdf"
  },
  {
    "name": "AP Lec 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/92293683391928560.pdf"
  },
  {
    "name": "AP Lec 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/676960613896997200.pdf"
  },
  {
    "name": "Triangles 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/62149823671252080.pdf"
  },
  {
    "name": "Triangles 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/58122284354803080.pdf"
  },
  {
    "name": "Triangles 3",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/653437686809603200.pdf"
  },
  {
    "name": "Trigonometry 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/343431223725968060.pdf"
  },
  {
    "name": "Trigonometry 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/48117576918428700.pdf"
  },
  {
    "name": "Trigonometry 3",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/673871983501041200.pdf"
  },
  {
    "name": "Coordinate GEO",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/129776331148052660.pdf"
  },
  {
    "name": "Application of Trigonometry",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/765948670731804300.pdf"
  },
  {
    "name": "Circle ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/683632629030908400.pdf"
  },
  {
    "name": "Circle ~ 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/593498988947856000.pdf"
  },
  {
    "name": "Area Rel to Circles Complete",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/798083316199754000.pdf"
  },
  {
    "name": "Doubt class + Surface Area & Volume 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/24340575576172508.pdf"
  },
  {
    "name": "Surface Area & Volume 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/342128652686218430.pdf"
  },
  {
    "name": "Statistics",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/661042206658621400.pdf"
  },
  {
    "name": "Probability",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/59083244009990380.pdf"
  }
],
    },
  Science:{
    0:[
  {
    "name": "Abhay Batch 10th Science - 1st FREE Class | Life Processes Lecture 1",
    "youtubeUrl": "https://www.youtube.com/live/3nnzRQEzIPM?si=RGeR2BuSULXKQO-D"
  },
  {
    "name": "Life Processes Lecture ~ 2",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251456/1733755749_6573603194055109/13027201.m3u8"
  },
  {
    "name": "Chemical Reaction & Equation Lecture ~ 1",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253595/1733950024_2453322930253138/sunny/1733924797386_831451836467571200_video_VOD.m3u8"
  },
  {
    "name": "Chemical Reaction & Equation Lecture ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4253634/173393608025118296383/173393608025118296383_8296383.m3u8"
  },
  {
    "name": "Light Lecture ~ 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4254694/173402301054458296383/173402301054458296383_8296383.m3u8"
  },
  {
    "name": "Light Lecture ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4255487/173410951379678296383/173410951379678296383_8296383.m3u8"
  },
  {
    "name": "Acid,Base And Salts",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4262636/173454164634708296383/173454164634708296383_8296383.m3u8"
  },
  {
    "name": "Control and Coordination L1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4263665/173462783779448296383/173462783779448296383_8296383.m3u8"
  },
  {
    "name": "Control and Coordination L2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4265525/173479976755458296383/173479976755458296383_8296383.m3u8"
  },
  {
    "name": "Metals and Non metals 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4267956/173514588477748296383/173514588477748296383_8296383.m3u8"
  },
  {
    "name": "Metals and Non metals 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4268799/173523205288808296383/173523205288808296383_8296383.m3u8"
  },
  {
    "name": "Electricity 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4269594/173531897040688296383/173531897040688296383_8296383.m3u8"
  },
  {
    "name": "Electricity 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4270084/173540638532658296383/173540638532658296383_8296383.m3u8"
  },
  {
    "name": "Human eye and colourful world",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4270256/173549276764798296383/173549276764798296383_8296383.m3u8"
  },
  {
    "name": "How do organism Reproduce 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4272066/173575152550008296383/173575152550008296383_8296383.m3u8"
  },
  {
    "name": "How do organism Reproduce 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4272759/173583743715928296383/173583743715928296383_8296383.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4274297/173609567488868296383/173609567488868296383_8296383.m3u8"
  },
  {
    name: "Carbon and Its compound 1",
    m3u8Url: "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4273638/173592491096628296383/173592491096628296383_8296383.m3u8"
  },
  {
    name: "Carbon and Its compound 2",
    m3u8Url: "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4274064/173601032973618296383/173601032973618296383_8296383.m3u8"
  },    
  {
    "name": "Our Environment",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4277220/173635622075408296383/173635622075408296383_8296383.m3u8"
  },
  {
    "name": "Heredity 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4278007/173644262877098296383/173644262877098296383_8296383.m3u8"
  },
  {
    "name": "Heredity L2 + Doubts",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4279009/173652841254688296383/173652841254688296383_8296383.m3u8"
  },
  {
    "name": "Magnetic Effect Of Current",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4279908/173669411663608296383/173669411663608296383_8296383.m3u8"
  },
  {
    "name": "Magnetic Effect Of Current ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4280773/173678830711658296383/173678830711658296383_8296383.m3u8"
  }
],
    1:[
  {
    "name": "Life Process Notes ~ 1",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/674ddba4f3662_Life_process_abhay_compressed.pdf"
  },
  {
    "name": "Life Process Notes ~ 2",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/67516c41e6867_Life_processes_compressed.pdf"
  },
  {
    "name": "NYQ ~ Life Processes",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/6752f707c8eae_NYQ_Life_Processes.pdf"
  },
  {
    "name": "Chemical Reaction and Equations ~ 1",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/6752f6ca57ca7_Chemical_Reaction_and_Equations_1_compressed.pdf"
  },
  {
    "name": "Chemical Reaction and Equations ~ 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/816747585997635700.pdf"
  },
  {
    "name": "NYQ ~ Chemical Reaction and Equations",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/397888009441713900.pdf"
  },
  {
    "name": "Light ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/762278810243444600.pdf"
  },
  {
    "name": "Light ~ 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/698430910684664200.pdf"
  },
  {
    "name": "NYQ ~ Light",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/309853370009596800.pdf"
  },
  {
    "name": "Acid Base and Salts",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/784441458869695200.pdf"
  },
  {
    "name": "NYQ ~ Acid Bases And Salts",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/352860421427277500.pdf"
  },
  {
    "name": "Control and coordination-1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/778213149411903400.pdf"
  },
  {
    "name": "Control and coordination - 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/813882703720479500.pdf"
  },
  {
    "name": "NYQ ~ Control and Coordination",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/753427301475617500.pdf"
  },
  {
    "name": "Metals and Non metals ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/855971683130441200.pdf"
  },
  {
    "name": "Metals and Non metals ~ 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/422160046272181060.pdf"
  },
  {
    "name": "NYQ ~ Metals and Non metals",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/515435289153315200.pdf"
  },
  {
    "name": "Electricity - 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/444972694363095200.pdf"
  },
  {
    "name": "Electricity - 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/746372557208473900.pdf"
  },
  {
    "name": "NYQ - Electricity",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/760520261346095200.pdf"
  },
  {
    "name": "Human eye and colourful world",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/196312281100859900.pdf"
  },
  {
    "name": "NYQ ~ Human eye and colourful world",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/393757362903381500.pdf"
  },
  {
    "name": "How do organism Reproduce ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/557483693449087040.pdf"
  },
  {
    "name": "How do organism Reproduce ~ 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/587718654192670300.pdf"
  },
  {
    "name": "NYQ ~ How do organism Reproduce",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/585883333144213400.pdf"
  },
  {
    "name": "Carbon and its compounds 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/681365270981829900.pdf"
  },
  {
    "name": "Carbon and its compounds 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/428269438989234200.pdf"
  },
  {
    "name": "NYQ ~ Carbon and its compounds",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/515276891802737860.pdf"
  },
  {
    "name": "Our Environment",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/62798052962255710.pdf"
  },
  {
    "name": "NYQ- Our Environment ( Prashant Kirad )",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/4125818NYQ-%20Our%20Environment%20%28%20Prashant%20Kirad%20%29.pdf_NYQ-%20Our%20Environment%20%28%20Prashant%20Kirad%20%29.pdf"
  },
  {
    "name": "Heredity and Evolution",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/816391908924907100.pdf"
  },
  {
    "name": "NYQ - Heredity (Prashant Kirad)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2592489_NYQ%20-%20Heredity%20%28Prashant%20Kirad%29.pdf__NYQ%20-%20Heredity%20%28Prashant%20Kirad%29.pdf"
  },
  {
    "name": "Magnetic Effects of electric Current",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/797883621364550500.pdf"
  },
  {
    "name": "Magnetic effects of electric current 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/14420712906606092.pdf"
  },
  {
    "name": "NYQ ~ Magnetic Effects of Electric Current",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/300347441426088900.pdf"
  }
],
  },
    SST:{
      0:[
  {
    "name": "Abhay Batch Social Science - 1st FREE Class | Development Lecture 1 | Class 10th",
    "youtubeUrl": "https://www.youtube.com/live/zpjt6qrOcSc?si=IuPYFlMPsoUU6IM9"
  },
  {
    "name": "Power Sharing ~ Lecture 1",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251449/1733760365_9732938186840908/sunny/1733754877833_492530338832128600_video_VOD.m3u8"
  },
  {
    "name": "Resource And Development ~ Lecture 1",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251457/1733755752_6661695992518788/13027202.m3u8"
  },
  {
    "name": "The Rise of Nationalism in Europe ~ Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4251354/173374969189251097666/173374969189251097666_1097666.m3u8"
  },
  {
    "name": "The Rise of Nationalism in Europe ~ Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4252320/173383668270021097666/173383668270021097666_1097666.m3u8"
  },
  {
    "name": "Doubt Solving class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4253520/173392314165591097666/173392314165591097666_1097666.m3u8"
  },
  {
    "name": "Sectors Of Indian Economy",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4254617/173401145393021097666/173401145393021097666_1097666.m3u8"
  },
  {
    "name": "Federalism",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4257475/173435570624611097666/173435570624611097666_1097666.m3u8"
  },
  {
    "name": "Forest and Wildlife Resources",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4261757/173444257421308296383/173444257421308296383_8296383.m3u8"
  },
  {
    "name": "Nationalism in India",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4262546/173452946639681097666/173452946639681097666_1097666.m3u8"
  },
  {
    "name": "Nationalism in India ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4263583/173461636536221097666/173461636536221097666_1097666.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4266360/173496005164118296383/173496005164118296383_8296383.m3u8"
  },
  {
    "name": "Money And Cradit",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4267208/173504796633348296383/173504796633348296383_8296383.m3u8"
  },
  {
    "name": "Gender Religion and Caste",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4267887/173513405978101097666/173513405978101097666_1097666.m3u8"
  },
  {
    "name": "Water Resources",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4268740/173522019765341097666/173522019765341097666_1097666.m3u8"
  },
  {
    "name": "The Making Of Golbal World & Globalization And The Indian Economy",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4270813/173556604344381097666/173556604344381097666_1097666.m3u8"
  },
  {
    "name": "Political Parties",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4271516/173565281077511097666/173565281077511097666_1097666.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4272033/173573726499381097666/173573726499381097666_1097666.m3u8"
  },
  {
    "name": "Agriculture",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4272708/173582507294081097666/173582507294081097666_1097666.m3u8"
  },
  {
    "name": "Print culture and the modern world ~ 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4275143/173617023050461097666/173617023050461097666_1097666.m3u8"
  },
  {
    "name": "Print culture and the modern world ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4276227/173625718154331097666/173625718154331097666_1097666.m3u8"
  },
  {
    "name": "Outcomes of Democracy",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4277163/173634378667551097666/173634378667551097666_1097666.m3u8"
  },
  {
    "name": "Minerals and Energy Resources",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4277953/173643003676811097666/173643003676811097666_1097666.m3u8"
  },
  {
    "name": "Minerals and Energy Resources ~ 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4280732/173677647279907880624/173677647279907880624_7880624.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4281273/173686022050777880624/173686022050777880624_7880624.m3u8"
  },
  {
    "name": "Map Work",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4282076/173694789382897880624/173694789382897880624_7880624.m3u8"
  }
    ],
      1:[
  {
    "name": "Development Notes",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/674ddc043f4d3_Economics_Development_2025_abhay.pdf"
  },
  {
    "name": "Power Sharing Notes",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/6750763b07e29_Power_Sharing.pdf"
  },
  {
    "name": "Resources and Development Notes",
    "redirect": "https://sina2s3.appextech.net/eaf754c93c304f27bd6a7931d6ef358a:nexttopper/class-attachment/6755469f3787a_GeographyResources_and_development.pdf"
  },
  {
    "name": "Rise Of Nationalism In Europe",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/849105351685101700.pdf"
  },
  {
    "name": "Sectors Of Indian Economy",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/90946492444117870.pdf"
  },
  {
    "name": "Federalism",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/451176755238626600.pdf"
  },
  {
    "name": "Forest And Wildlife Resources",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/395204569053737860.pdf"
  },
  {
    "name": "Nationalism in India",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/411965340595102000.pdf"
  },
  {
    "name": "Gender Religion and Caste",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/7413531559370723.pdf"
  },
  {
    "name": "Money And Cradit",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/382310699174122400.pdf"
  },
  {
    "name": "Water Resources ~ 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/3082611Geography_Water%20Resources%20.pdf_Geography_Water%20Resources%20.pdf"
  },
  {
    "name": "Water Resources ~ 2",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/226019399154036100.pdf"
  },
  {
    "name": "The Making Of Global World",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/898695164355736300.pdf"
  },
  {
    "name": "Globalization And The Indian Economy",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/428947563182653250.pdf"
  },
  {
    "name": "Political Parties",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/590890725340960400.pdf"
  },
  {
    "name": "Agriculture",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/510421195098938400.pdf"
  },
  {
    "name": "Print Culture and the Modern World",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/698427668306168000.pdf"
  },
  {
    "name": "Outcomes of Democracy",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/652445193069653400.pdf"
  },
  {
    "name": "Minerals and Energy Resources",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/817565576726923900.pdf"
  },
  {
    "name": "Minerals and Energy Resources",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/84913621948071570.pdf"
  },
  {
    "name": "Manufacturing Industries",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/230312427208407870.pdf"
  },
  {
    "name": "Complete Map Work",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/658635943380250200.pdf"
  }
]
    },
    English:{
      0:[
  {
    "name": "A Letter to God Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251745/1733812805_6669127390642374/sunny/1733811949451_319070340622534500_video_VOD.m3u8"
  },
  {
    "name": "Poetic Devices - Crash Course Class 10th Grammar English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253545/1733940857_7033121976921162/sunny/1733924007365_129353821078791460_video_VOD.m3u8"
  },
  {
    "name": "Fire and Ice Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276782/1736331426_5473233716376188/sunny/1736330097093_197099440846746370_video_VOD.m3u8"
  },
  {
    "name": "Nelson Mandela Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251746/1733812924_6140525597470411/sunny/1733812178966_459089907257075460_video_VOD.m3u8"
  },
  {
    "name": "Two Story About Flying Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251747/1733812984_7813568048002038/sunny/1733812286984_638131486549655400_video_VOD.m3u8"
  },
  {
    "name": "From The Diary if Anne Frank Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251744/1733812564_9405240253897293/sunny/1733811791350_716782271842089600_video_VOD.m3u8"
  },
  {
    "name": "Triump Of Surgery Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251721/1733811669_6377962928970336/sunny/1733811541382_52918433541798616_video_VOD.m3u8"
  },
  {
    "name": "Thief Story Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251720/1733811667_1057806415401295/sunny/1733811467415_692067384261568600_video_VOD.m3u8"
  },
  {
    "name": "Midnight Visitor Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4251719/1733811665_6029335743468548/sunny/1733811392784_288872064705293500_video_VOD.m3u8"
  },
  {
    "name": "Determiners Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253578/1733948225_8521669959222553/sunny/1733924899590_428071811491329700_video_VOD.m3u8"
  },
  {
    "name": "Subject verb agreement Crash Course Class 10th English",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253579/1733948884_2823229140783152/sunny/1733924932578_151177171928495800_video_VOD.m3u8"
  },
  {
    "name": "Dust of Snow",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264816/1734724923_2825433205059306/sunny/1734703434690_262103153668982400_video_VOD.m3u8"
  },
  {
    "name": "The Trees Crash Course",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264823/1734723545_7219363522242197/sunny/1734703578839_108078548756681700_video_VOD.m3u8"
  },
  {
    "name": "Tiger in the Zoo",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264830/1734724568_3184767951464150/sunny/1734703894487_613668910112767000_video_VOD.m3u8"
  },
  {
    "name": "The ball poem",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264821/1734725706_1724482114240255/sunny/1734703559467_480625697031120200_video_VOD.m3u8"
  },
  {
    "name": "How to Tell Wild Animals",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264833/1734726243_7506825549677102/sunny/1734703980118_774783253298749800_video_VOD.m3u8"
  },
  {
    "name": "Glimpses of India",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264851/1734728046_4386884852151518/sunny/1734705999051_632074669036653800_video_VOD.m3u8"
  },
  {
    "name": "Amanda",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264850/1734727744_5907593079194306/sunny/1734705947769_421956682824980100_video_VOD.m3u8"
  },
  {
    "name": "Mijbil the Otter",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4264817/1734724985_4825910924265795/sunny/1734703460884_436374741398228700_video_VOD.m3u8"
  },
  {
    "name": "Two Gentlemen of Verona",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4266239/1734950943_9036487778687420/sunny/1734950887736_850281154888705000_video_VOD.m3u8"
  },
  {
    "name": "Mrs Packletide's Tiger",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4266240/1734951004_9252964508964003/sunny/1734950951137_792971009778331000_video_VOD.m3u8"
  },
  {
    "name": "The Frog and the Nightingale",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4267327/1735099875_9256700557341940/sunny/1735099324207_33625927050285000_video_VOD.m3u8"
  },
  {
    "name": "Not Marble, Nor the Gilded Mountains",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4267326/1735099873_9861991859780301/sunny/1735099295725_613852473111631000_video_VOD.m3u8"
  },
  {
    "name": "Ozymandias",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4267325/1735099871_8802548625455708/sunny/1735099274897_886792200289386100_video_VOD.m3u8"
  },
  {
    "name": "Bholi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274264/1736092996_3735019783339238/sunny/1736077707070_891106798368463600_video_VOD.m3u8"
  },
  {
    "name": "Fog",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274265/1736093104_4384985256802095/sunny/1736077779082_508857149610710700_video_VOD.m3u8"
  },
  {
    "name": "Footprints Without Feet",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274266/1736093883_6895755692850579/sunny/1736077842181_156380152369321660_video_VOD.m3u8"
  },
  {
    "name": "Meaning of Scientist",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274257/1736093224_8492794277975089/sunny/1736077147564_472756965082054460_video_VOD.m3u8"
  },
  {
    "name": "A Question of Trust",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274259/1736093404_1250635928417320/sunny/1736077261271_502661971259156350_video_VOD.m3u8"
  },
  {
    "name": "The Necklace",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274261/1736093644_9560971891368266/sunny/1736077412990_523480438614458750_video_VOD.m3u8"
  },
  {
    "name": "The Proposal",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274262/1736092504_4367986689208953/sunny/1736077517655_539028473760344260_video_VOD.m3u8"
  },
  {
    "name": "For Anne Gregory",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276779/1736330884_6232699255388216/sunny/1736327698067_890188066385735400_video_VOD.m3u8"
  },
  {
    "name": "Madam Rides the Bus",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276780/1736331124_9757160315394537/sunny/1736328201541_414464910712537000_video_VOD.m3u8"
  },
  {
    "name": "The Tale of Custard the Dragon",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276781/1736331304_7127373976208863/sunny/1736328689204_61900352842252856_video_VOD.m3u8"
  },
  {
    "name": "Fire and Ice",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276782/1736331426_5473233716376188/sunny/1736330097093_197099440846746370_video_VOD.m3u8"
  },
  {
    "name": "The Sermon at Benaras",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276783/1736331724_3801453607884863/sunny/1736330167720_396076506338308740_video_VOD.m3u8"
  },
  {
    "name": "Error Correction",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274224/1736091963_9735582651178524/sunny/1736076818979_281643245727468960_video_VOD.m3u8"
  },
  {
    "name": "Reported Speech",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274222/1736090884_5867749472320186/sunny/1736076649664_848121367528233000_video_VOD.m3u8"
  },
  {
    "name": "Subject Verb Agreement",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274223/1736091483_3365574023283278/sunny/1736076784302_153862875780487100_video_VOD.m3u8"
  },
  {
    "name": "Models",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276673/1736326084_2153988996921084/sunny/1736324540384_455686712491424960_video_VOD.m3u8"
  },
  {
    "name": "Patol Babu",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274273/1736094183_5493624989195366/sunny/1736079952596_368792336154628700_video_VOD.m3u8"
  },
  {
    "name": "A Shady Plot",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4276764/1736329984_7503880013004136/sunny/1736329009963_245369703423326940_video_VOD.m3u8"
  },
  {
    "name": "The Letter",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4274274/1736094185_5735778037601183/sunny/1736080032260_376445638585879940_video_VOD.m3u8"
  },
  {
    "name": "English Doubt Session",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4274270/173608092211731097666/173608092211731097666_1097666.m3u8"
  }
],
      1:[
  {
    "name": "Midnight Visitor",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/416456882918510400.pdf"
  },
  {
    "name": "Thief Story",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/597354045114689500.pdf"
  },
  {
    "name": "Diary of Anne Frank",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/6824155Class%2010%20Diary%20of%20Anne%20Frank.pdf.pdf_Class%2010%20Diary%20of%20Anne%20Frank.pdf.pdf"
  },
  {
    "name": "A letter  to god",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/3141029Class%2010%20English%20chapter%201%20letter%20%20to%20god.pdf.pdf_Class%2010%20English%20chapter%201%20letter%20%20to%20god.pdf.pdf"
  },
  {
    "name": "Two stories about flying",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/912162Class%2010%20Two%20stories%20about%20flying.pdf.pdf_Class%2010%20Two%20stories%20about%20flying.pdf.pdf"
  },
  {
    "name": "Nelson Mandela",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/5502009Class%2010NelsonMandela.pdf.pdf_Class%2010NelsonMandela.pdf.pdf"
  },
  {
    "name": "Amanda",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/395031907997568500.pdf"
  },
  {
    "name": "Glimpses of india",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/625340327694686000.pdf"
  },
  {
    "name": "How to tell wild animals",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/251080599146297150.pdf"
  },
  {
    "name": "Mrs Packletide's Tiger",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/3534086Mrs%20Packletide%27s%20Tiger.pdf_Mrs%20Packletide%27s%20Tiger.pdf"
  },
  {
    "name": "Not Marble, Nor the Gilded Mountains",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2227042Not%20Marble%2C%20Nor%20the%20Gilded%20Mountains.pdf_Not%20Marble%2C%20Nor%20the%20Gilded%20Mountains.pdf"
  },
  {
    "name": "Two Gentlemen of Verona",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2389657Two%20Gentlemen%20of%20Verona.pdf_Two%20Gentlemen%20of%20Verona.pdf"
  },
  {
    "name": "The Frog and the Nightingale",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2487679The%20Frog%20and%20the%20Nightingale.pdf_The%20Frog%20and%20the%20Nightingale.pdf"
  }
],
    },
    Hindi:{
      0:[
  {
    "name": "पाठ 1 साखी (कबीर) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253263/1733927403_7336321494334485/sunny/1733912461680_654231427176261200_video_VOD.m3u8"
  },
  {
    "name": "पाठ 2 पद ( मीरा ) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253266/1733928483_8046744047804611/sunny/1733913022012_267583581313674400_video_VOD.m3u8"
  },
  {
    "name": "पाठ 3 मनुष्यता (मैथिलीशरण गुप्त) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253287/1733928785_7593462916168240/sunny/1733913883213_139820517345038740_video_VOD.m3u8"
  },
  {
    "name": "पाठ 4 पर्वत प्रदेश में पावस (सुमित्रानंदन पंत) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253288/1733929984_8007989545176215/sunny/1733914036988_598632065195117200_video_VOD.m3u8"
  },
  {
    "name": "पाठ 5 तोप (वीरेन डंगवाल) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253292/1733931187_6423775906750624/sunny/1733914160542_199878584980891230_video_VOD.m3u8"
  },
  {
    "name": "संचयन भाग 2 पाठ 1 हरिहर काका (मिथिलेश्वर) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4262619/1734540544_1441623331661678/1734538448300_273427179877811970_video_VOD.m3u8"
  },
  {
    "name": "संचयन भाग 2 पाठ 2 सपनों के - से दिन ( गुरदयाल सिंह ) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4262620/1734541864_9548261217552686/1734539479136_187723873675737340_video_VOD.m3u8"
  },
  {
    "name": "संचयन भाग 2 पाठ 3 टोपी शुक्ला ( राही मासूम रज़ा ) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4262621/1734543064_6153467030202153/1734539914678_302310418907737400_video_VOD.m3u8"
  },
  {
    "name": "कृतिका भाग 2 पाठ 1 शिवपूजन सहाय (माता का अँचल)",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4261853/1734469083_8010360225537367/sunny/1734467149903_128695936795052720_video_VOD.m3u8"
  },
  {
    "name": "कृतिका भाग 2 पाठ 2 साना-साना हाथ जोड़ि",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4261854/1734471783_6343544696493508/sunny/1734470331657_542410746548183740_video_VOD.m3u8"
  },
  {
    "name": "कृतिका भाग 2 पाठ 3 मैं क्यों लिखता हूँ (अज्ञेय)",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4261855/1734472744_3498136710282829/sunny/1734472036255_829311107236598300_video_VOD.m3u8"
  },
  {
    "name": "पाठ 2 राम - लक्ष्मण - परशुराम संवाद (तुलसीदास) - Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4262401/1734522124_6050313455582864/sunny/1734518843579_674308211424009500_video_VOD.m3u8"
  },
  {
    "name": "पाठ 3 आत्मकथ्य (जयशंकर प्रसाद) - Crash Course",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4262402/1734522483_1262396176184697/sunny/1734519611341_641578534313167200_video_VOD.m3u8"
  },
  {
    "name": "पाठ 6 कर चले हम फ़िदा (कैफ़ी आज़मी)",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268430/1735213026_4105743514154312/sunny/1735206681758_634096561687456000_video_VOD.m3u8"
  },
  {
    "name": "पाठ 7 आत्मत्राण (रवींद्रनाथ ठाकुर)",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268429/1735213024_8539750247570806/sunny/1735206595885_755522759990663700_video_VOD.m3u8"
  },
  {
    "name": "पाठ 8 बड़े भाई साहब (प्रेमचंद) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268432/1735212904_1718034997213631/sunny/1735206840667_326137583305440060_video_VOD.m3u8"
  },
  {
    "name": "स्पर्श भाग 2 पाठ 9 डायरी का एक पन्ना ( सीताराम सेकसरिया ) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268431/1735214103_3160224284661868/sunny/1735206716271_393844639984746430_video_VOD.m3u8"
  },
  {
    "name": "स्पर्श भाग 2 पाठ 10 तताँरा - वामीरो कथा ( लीलाधर मंडलोई ) Crash Course",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268433/1735214164_7990051744731923/sunny/1735207194353_789950068875261300_video_VOD.m3u8"
  },
  {
    "name": "सूरदास पद",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4265352/1734785584_7914366619803900/sunny/1734778838998_15832657047803566_video_VOD.m3u8"
  },
  {
    "name": "पाठ 6 संगतकार (मंगलेश डबराल) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268400/1735210804_4631654611857911/sunny/1735203847601_153274826733715800_video_VOD.m3u8"
  },
  {
    "name": "पाठ 7 नेताजी का चश्मा (स्वयं प्रकाश) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268404/1735209425_6839227176203922/sunny/1735204720491_4387271647955493_video_VOD.m3u8"
  },
  {
    "name": "पाठ 8 बालगोबिन भगत (रामवृक्ष बेनीपुरी) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268403/1735208164_8465910100789091/sunny/1735204491913_780712928676890900_video_VOD.m3u8"
  },
  {
    "name": "पाठ 9 लखनवी अंदाज़ (यशपाल) Crash Course Class 10th Hindi",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268398/1735209005_8217337063872748/sunny/1735203394209_78558880027450770_video_VOD.m3u8"
  },
  {
    "name": "पाठ 10 एक कहानी यह भी (मन्नू भंडारी) Crash Course",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268402/1735211586_6373106706001113/sunny/1735204191649_472757226855847100_video_VOD.m3u8"
  },
  {
    "name": "पाठ 4 उत्साह, अट नहीं रही है (सूर्यकांत त्रिपाठी 'निराला')-Crash Course",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269814/1735373646_5856621950223021/sunny/1735372626450_873208663131423000_video_VOD.m3u8"
  },
  {
    "name": "पाठ 5 यह दंतुरित मुसकान ,फसल (नागार्जुन) Crash Course",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269815/1735373648_9093494352125561/sunny/1735373153252_851414385027167600_video_VOD.m3u8"
  },
  {
    "name": "मुहावरे",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268619/1735227185_7179342094011848/sunny/1735212878251_471939946508238200_video_VOD.m3u8"
  },
  {
    "name": "रचना के आधार पर वाक्य रूपांतर",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268616/1735228279_2744701414843389/sunny/1735212742127_147302200720775400_video_VOD.m3u8"
  },
  {
    "name": "पदबंध",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268309/1735201264_7243611888481815/sunny/1735200593840_69789172532661130_video_VOD.m3u8"
  },
  {
    "name": "सूचना लेखन",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268308/1735200909_2118627412163361/sunny/1735200562846_70554822881978344_video_VOD.m3u8"
  },
  {
    "name": "समास",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268614/1735227785_2514394730726396/sunny/1735212618070_451657041564753900_video_VOD.m3u8"
  },
  {
    "name": "संदेश लेखन",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268611/1735227304_2447411382482060/sunny/1735212506365_802626150321363700_video_VOD.m3u8"
  },
  {
    "name": "लघुकथा लेखन-व्याकरण",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4268618/1735227257_6322642433010980/sunny/1735212834292_255995190399674430_video_VOD.m3u8"
  },
  {
    "name": "Course A Complete Summary",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4284923/173721102460051097666/173721102460051097666_1097666.m3u8"
  }
],
      1:[
  {
    "name": "पाठ 1 साखी (कबीर) Crash Course Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/826588%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%201%20%E0%A4%B8%E0%A4%BE%E0%A4%96%E0%A5%80%20%28%E0%A4%95%E0%A4%AC%E0%A5%80%E0%A4%B0%29%20Crash%20Course%20Hindi%20.pdf_%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%201%20%E0%A4%B8%E0%A4%BE%E0%A4%96%E0%A5%80%20%28%E0%A4%95%E0%A4%AC%E0%A5%80%E0%A4%B0%29%20Crash%20Course%20Hindi%20.pdf"
  },
  {
    "name": "पाठ 2 पद ( मीरा ) Crash Course Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/1959819%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%AA%E0%A4%A6%20%28%20%E0%A4%AE%E0%A5%80%E0%A4%B0%E0%A4%BE%20%29%20Crash%20Course%20Hindi%20.pdf_%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%AA%E0%A4%A6%20%28%20%E0%A4%AE%E0%A5%80%E0%A4%B0%E0%A4%BE%20%29%20Crash%20Course%20Hindi%20.pdf"
  },
  {
    "name": "पाठ 3 मनुष्यता (मैथिलीशरण गुप्त)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/4925651%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%AE%E0%A4%A8%E0%A5%81%E0%A4%B7%E0%A5%8D%E0%A4%AF%E0%A4%A4%E0%A4%BE%20%28%E0%A4%AE%E0%A5%88%E0%A4%A5%E0%A4%BF%E0%A4%B2%E0%A5%80%E0%A4%B6%E0%A4%B0%E0%A4%A3%20%E0%A4%97%E0%A5%81%E0%A4%AA%E0%A5%8D%E0%A4%A4%29.pdf_%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%AE%E0%A4%A8%E0%A5%81%E0%A4%B7%E0%A5%8D%E0%A4%AF%E0%A4%A4%E0%A4%BE%20%28%E0%A4%AE%E0%A5%88%E0%A4%A5%E0%A4%BF%E0%A4%B2%E0%A5%80%E0%A4%B6%E0%A4%B0%E0%A4%A3%20%E0%A4%97%E0%A5%81%E0%A4%AA%E0%A5%8D%E0%A4%A4%29.pdf"
  },
  {
    "name": "स्पर्श पाठ 4 पर्वत प्रदेश में पावस (सुमित्रानंदन पंत)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/6870194PDF%20%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%204%20%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B5%E0%A4%A4%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A4%A6%E0%A5%87%E0%A4%B6%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%AA%E0%A4%BE%E0%A4%B5%E0%A4%B8%20%28%E0%A4%B8%E0%A5%81%E0%A4%AE%E0%A4%BF%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%A8%E0%A4%82%E0%A4%A6%E0%A4%A8%20%E0%A4%AA%E0%A4%82%E0%A4%A4%29.pdf_PDF%20%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%204%20%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B5%E0%A4%A4%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A4%A6%E0%A5%87%E0%A4%B6%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%AA%E0%A4%BE%E0%A4%B5%E0%A4%B8%20%28%E0%A4%B8%E0%A5%81%E0%A4%AE%E0%A4%BF%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%A8%E0%A4%82%E0%A4%A6%E0%A4%A8%20%E0%A4%AA%E0%A4%82%E0%A4%A4%29.pdf"
  },
  {
    "name": "आत्मत्राण (रवींद्रनाथ ठाकुर) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/1200005%E0%A4%AA%E0%A4%BE%E0%A4%A0%207%20%E0%A4%86%E0%A4%A4%E0%A5%8D%E0%A4%AE%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%A3%20%28%E0%A4%B0%E0%A4%B5%E0%A5%80%E0%A4%82%E0%A4%A6%E0%A5%8D%E0%A4%B0%E0%A4%A8%E0%A4%BE%E0%A4%A5%20%E0%A4%A0%E0%A4%BE%E0%A4%95%E0%A5%81%E0%A4%B0%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%AA%E0%A4%BE%E0%A4%A0%207%20%E0%A4%86%E0%A4%A4%E0%A5%8D%E0%A4%AE%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%A3%20%28%E0%A4%B0%E0%A4%B5%E0%A5%80%E0%A4%82%E0%A4%A6%E0%A5%8D%E0%A4%B0%E0%A4%A8%E0%A4%BE%E0%A4%A5%20%E0%A4%A0%E0%A4%BE%E0%A4%95%E0%A5%81%E0%A4%B0%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "8 बड़े भाई साहब (प्रेमचंद) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2179822%E0%A4%AA%E0%A4%BE%E0%A4%A0%208%20%E0%A4%AC%E0%A4%A1%E0%A4%BC%E0%A5%87%20%E0%A4%AD%E0%A4%BE%E0%A4%88%20%E0%A4%B8%E0%A4%BE%E0%A4%B9%E0%A4%AC%20%28%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%AE%E0%A4%9A%E0%A4%82%E0%A4%A6%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%AA%E0%A4%BE%E0%A4%A0%208%20%E0%A4%AC%E0%A4%A1%E0%A4%BC%E0%A5%87%20%E0%A4%AD%E0%A4%BE%E0%A4%88%20%E0%A4%B8%E0%A4%BE%E0%A4%B9%E0%A4%AC%20%28%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%AE%E0%A4%9A%E0%A4%82%E0%A4%A6%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 9 डायरी का एक पन्ना ( सीताराम सेकसरिया ) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/4840724%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%209%20%E0%A4%A1%E0%A4%BE%E0%A4%AF%E0%A4%B0%E0%A5%80%20%E0%A4%95%E0%A4%BE%20%E0%A4%8F%E0%A4%95%20%E0%A4%AA%E0%A4%A8%E0%A5%8D%E0%A4%A8%E0%A4%BE%20%28%20%E0%A4%B8%E0%A5%80%E0%A4%A4%E0%A4%BE%E0%A4%B0%E0%A4%BE%E0%A4%AE%20%E0%A4%B8%E0%A5%87%E0%A4%95%E0%A4%B8%E0%A4%B0%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%209%20%E0%A4%A1%E0%A4%BE%E0%A4%AF%E0%A4%B0%E0%A5%80%20%E0%A4%95%E0%A4%BE%20%E0%A4%8F%E0%A4%95%20%E0%A4%AA%E0%A4%A8%E0%A5%8D%E0%A4%A8%E0%A4%BE%20%28%20%E0%A4%B8%E0%A5%80%E0%A4%A4%E0%A4%BE%E0%A4%B0%E0%A4%BE%E0%A4%AE%20%E0%A4%B8%E0%A5%87%E0%A4%95%E0%A4%B8%E0%A4%B0%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 10 तताँरा - वामीरो कथा ( लीलाधर मंडलोई ) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/5971041%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%2010%20%E0%A4%A4%E0%A4%A4%E0%A4%BE%E0%A4%81%E0%A4%B0%E0%A4%BE%20-%20%E0%A4%B5%E0%A4%BE%E0%A4%AE%E0%A5%80%E0%A4%B0%E0%A5%8B%20%E0%A4%95%E0%A4%A5%E0%A4%BE%20%28%20%E0%A4%B2%E0%A5%80%E0%A4%B2%E0%A4%BE%E0%A4%A7%E0%A4%B0%20%E0%A4%AE%E0%A4%82%E0%A4%A1%E0%A4%B2%E0%A5%8B%E0%A4%88%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%2010%20%E0%A4%A4%E0%A4%A4%E0%A4%BE%E0%A4%81%E0%A4%B0%E0%A4%BE%20-%20%E0%A4%B5%E0%A4%BE%E0%A4%AE%E0%A5%80%E0%A4%B0%E0%A5%8B%20%E0%A4%95%E0%A4%A5%E0%A4%BE%20%28%20%E0%A4%B2%E0%A5%80%E0%A4%B2%E0%A4%BE%E0%A4%A7%E0%A4%B0%20%E0%A4%AE%E0%A4%82%E0%A4%A1%E0%A4%B2%E0%A5%8B%E0%A4%88%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 6 कर चले हम फ़िदा (कैफ़ी आज़मी)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/6541275%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%206%20%E0%A4%95%E0%A4%B0%20%E0%A4%9A%E0%A4%B2%E0%A5%87%20%E0%A4%B9%E0%A4%AE%20%E0%A4%AB%E0%A4%BC%E0%A4%BF%E0%A4%A6%E0%A4%BE%20%28%E0%A4%95%E0%A5%88%E0%A4%AB%E0%A4%BC%E0%A5%80%20%E0%A4%86%E0%A4%9C%E0%A4%BC%E0%A4%AE%E0%A5%80%29.pdf_%E0%A4%B8%E0%A5%8D%E0%A4%AA%E0%A4%B0%E0%A5%8D%E0%A4%B6%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%206%20%E0%A4%95%E0%A4%B0%20%E0%A4%9A%E0%A4%B2%E0%A5%87%20%E0%A4%B9%E0%A4%AE%20%E0%A4%AB%E0%A4%BC%E0%A4%BF%E0%A4%A6%E0%A4%BE%20%28%E0%A4%95%E0%A5%88%E0%A4%AB%E0%A4%BC%E0%A5%80%20%E0%A4%86%E0%A4%9C%E0%A4%BC%E0%A4%AE%E0%A5%80%29.pdf"
  },
  {
    "name": "पाठ 5 तोप (वीरेन डंगवाल)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/582092440615362700.pdf"
  },
  {
    "name": "भाग 2 पाठ 1 शिवपूजन सहाय (माता का अँचल) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/7357851%E0%A4%95%E0%A5%83%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%201%20%E0%A4%B6%E0%A4%BF%E0%A4%B5%E0%A4%AA%E0%A5%82%E0%A4%9C%E0%A4%A8%20%E0%A4%B8%E0%A4%B9%E0%A4%BE%E0%A4%AF%20%28%E0%A4%AE%E0%A4%BE%E0%A4%A4%E0%A4%BE%20%E0%A4%95%E0%A4%BE%20%E0%A4%85%E0%A4%81%E0%A4%9A%E0%A4%B2%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%95%E0%A5%83%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%201%20%E0%A4%B6%E0%A4%BF%E0%A4%B5%E0%A4%AA%E0%A5%82%E0%A4%9C%E0%A4%A8%20%E0%A4%B8%E0%A4%B9%E0%A4%BE%E0%A4%AF%20%28%E0%A4%AE%E0%A4%BE%E0%A4%A4%E0%A4%BE%20%E0%A4%95%E0%A4%BE%20%E0%A4%85%E0%A4%81%E0%A4%9A%E0%A4%B2%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 2 साना-साना हाथ जोड़ि (मधु कांकरिया)",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/5403078%E0%A4%95%E0%A5%83%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%B8%E0%A4%BE%E0%A4%A8%E0%A4%BE-%E0%A4%B8%E0%A4%BE%E0%A4%A8%E0%A4%BE%20%E0%A4%B9%E0%A4%BE%E0%A4%A5%20%E0%A4%9C%E0%A5%8B%E0%A4%A1%E0%A4%BC%E0%A4%BF%20%28%E0%A4%AE%E0%A4%A7%E0%A5%81%20%E0%A4%95%E0%A4%BE%E0%A4%82%E0%A4%95%E0%A4%B0%E0%A4%BF%E0%A4%AF%E0%A4%BE%29.pdf_%E0%A4%95%E0%A5%83%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%B8%E0%A4%BE%E0%A4%A8%E0%A4%BE-%E0%A4%B8%E0%A4%BE%E0%A4%A8%E0%A4%BE%20%E0%A4%B9%E0%A4%BE%E0%A4%A5%20%E0%A4%9C%E0%A5%8B%E0%A4%A1%E0%A4%BC%E0%A4%BF%20%28%E0%A4%AE%E0%A4%A7%E0%A5%81%20%E0%A4%95%E0%A4%BE%E0%A4%82%E0%A4%95%E0%A4%B0%E0%A4%BF%E0%A4%AF%E0%A4%BE%29.pdf"
  },
  {
    "name": "भाग 2 पाठ 3 मैं क्यों लिखता हूँ (अज्ञेय) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/1201918%E0%A4%95%E0%A5%83%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%AE%E0%A5%88%E0%A4%82%20%E0%A4%95%E0%A5%8D%E0%A4%AF%E0%A5%8B%E0%A4%82%20%E0%A4%B2%E0%A4%BF%E0%A4%96%E0%A4%A4%E0%A4%BE%20%E0%A4%B9%E0%A5%82%E0%A4%81%20%28%E0%A4%85%E0%A4%9C%E0%A5%8D%E0%A4%9E%E0%A5%87%E0%A4%AF%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%95%E0%A5%83%E0%A4%A4%E0%A4%BF%E0%A4%95%E0%A4%BE%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%AE%E0%A5%88%E0%A4%82%20%E0%A4%95%E0%A5%8D%E0%A4%AF%E0%A5%8B%E0%A4%82%20%E0%A4%B2%E0%A4%BF%E0%A4%96%E0%A4%A4%E0%A4%BE%20%E0%A4%B9%E0%A5%82%E0%A4%81%20%28%E0%A4%85%E0%A4%9C%E0%A5%8D%E0%A4%9E%E0%A5%87%E0%A4%AF%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "Course A सूरदास पद-Crash Course  Part - 1",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2734627Course%20A%20%E0%A4%B8%E0%A5%82%E0%A4%B0%E0%A4%A6%E0%A4%BE%E0%A4%B8%20%E0%A4%AA%E0%A4%A6-Crash%20Course%20%20Part-%201.pdf_Course%20A%20%E0%A4%B8%E0%A5%82%E0%A4%B0%E0%A4%A6%E0%A4%BE%E0%A4%B8%20%E0%A4%AA%E0%A4%A6-Crash%20Course%20%20Part-%201.pdf"
  },
  {
    "name": "2 राम - लक्ष्मण - परशुराम संवाद (तुलसीदास)-Crash Course",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2555397%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%B0%E0%A4%BE%E0%A4%AE%20-%20%E0%A4%B2%E0%A4%95%E0%A5%8D%E0%A4%B7%E0%A5%8D%E0%A4%AE%E0%A4%A3%20-%20%E0%A4%AA%E0%A4%B0%E0%A4%B6%E0%A5%81%E0%A4%B0%E0%A4%BE%E0%A4%AE%20%E0%A4%B8%E0%A4%82%E0%A4%B5%E0%A4%BE%E0%A4%A6%20%28%E0%A4%A4%E0%A5%81%E0%A4%B2%E0%A4%B8%E0%A5%80%E0%A4%A6%E0%A4%BE%E0%A4%B8%29-Crash%20Course.pdf_%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%B0%E0%A4%BE%E0%A4%AE%20-%20%E0%A4%B2%E0%A4%95%E0%A5%8D%E0%A4%B7%E0%A5%8D%E0%A4%AE%E0%A4%A3%20-%20%E0%A4%AA%E0%A4%B0%E0%A4%B6%E0%A5%81%E0%A4%B0%E0%A4%BE%E0%A4%AE%20%E0%A4%B8%E0%A4%82%E0%A4%B5%E0%A4%BE%E0%A4%A6%20%28%E0%A4%A4%E0%A5%81%E0%A4%B2%E0%A4%B8%E0%A5%80%E0%A4%A6%E0%A4%BE%E0%A4%B8%29-Crash%20Course.pdf"
  },
  {
    "name": "3 आत्मकथ्य (जयशंकर प्रसाद)-Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/4990009%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%86%E0%A4%A4%E0%A5%8D%E0%A4%AE%E0%A4%95%E0%A4%A5%E0%A5%8D%E0%A4%AF%20%28%E0%A4%9C%E0%A4%AF%E0%A4%B6%E0%A4%82%E0%A4%95%E0%A4%B0%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A4%B8%E0%A4%BE%E0%A4%A6%29-Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%86%E0%A4%A4%E0%A5%8D%E0%A4%AE%E0%A4%95%E0%A4%A5%E0%A5%8D%E0%A4%AF%20%28%E0%A4%9C%E0%A4%AF%E0%A4%B6%E0%A4%82%E0%A4%95%E0%A4%B0%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A4%B8%E0%A4%BE%E0%A4%A6%29-Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "4 उत्साह, अट नहीं रही है (सूर्यकांत त्रिपाठी _निराला_)-Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/842010%E0%A4%AA%E0%A4%BE%E0%A4%A0%204%20%E0%A4%89%E0%A4%A4%E0%A5%8D%E0%A4%B8%E0%A4%BE%E0%A4%B9%2C%20%E0%A4%85%E0%A4%9F%20%E0%A4%A8%E0%A4%B9%E0%A5%80%E0%A4%82%20%E0%A4%B0%E0%A4%B9%E0%A5%80%20%E0%A4%B9%E0%A5%88%20%28%E0%A4%B8%E0%A5%82%E0%A4%B0%E0%A5%8D%E0%A4%AF%E0%A4%95%E0%A4%BE%E0%A4%82%E0%A4%A4%20%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A4%BF%E0%A4%AA%E0%A4%BE%E0%A4%A0%E0%A5%80%20_%E0%A4%A8%E0%A4%BF%E0%A4%B0%E0%A4%BE%E0%A4%B2%E0%A4%BE_%29-Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%AA%E0%A4%BE%E0%A4%A0%204%20%E0%A4%89%E0%A4%A4%E0%A5%8D%E0%A4%B8%E0%A4%BE%E0%A4%B9%2C%20%E0%A4%85%E0%A4%9F%20%E0%A4%A8%E0%A4%B9%E0%A5%80%E0%A4%82%20%E0%A4%B0%E0%A4%B9%E0%A5%80%20%E0%A4%B9%E0%A5%88%20%28%E0%A4%B8%E0%A5%82%E0%A4%B0%E0%A5%8D%E0%A4%AF%E0%A4%95%E0%A4%BE%E0%A4%82%E0%A4%A4%20%E0%A4%A4%E0%A5%8D%E0%A4%B0%E0%A4%BF%E0%A4%AA%E0%A4%BE%E0%A4%A0%E0%A5%80%20_%E0%A4%A8%E0%A4%BF%E0%A4%B0%E0%A4%BE%E0%A4%B2%E0%A4%BE_%29-Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 1 हरिहर काका (मिथिलेश्वर) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2532555%E0%A4%B8%E0%A4%82%E0%A4%9A%E0%A4%AF%E0%A4%A8%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%201%20%E0%A4%B9%E0%A4%B0%E0%A4%BF%E0%A4%B9%E0%A4%B0%20%E0%A4%95%E0%A4%BE%E0%A4%95%E0%A4%BE%20%28%E0%A4%AE%E0%A4%BF%E0%A4%A5%E0%A4%BF%E0%A4%B2%E0%A5%87%E0%A4%B6%E0%A5%8D%E0%A4%B5%E0%A4%B0%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%B8%E0%A4%82%E0%A4%9A%E0%A4%AF%E0%A4%A8%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%201%20%E0%A4%B9%E0%A4%B0%E0%A4%BF%E0%A4%B9%E0%A4%B0%20%E0%A4%95%E0%A4%BE%E0%A4%95%E0%A4%BE%20%28%E0%A4%AE%E0%A4%BF%E0%A4%A5%E0%A4%BF%E0%A4%B2%E0%A5%87%E0%A4%B6%E0%A5%8D%E0%A4%B5%E0%A4%B0%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 2 सपनों के - से दिन ( गुरदयाल सिंह ) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/5078430%E0%A4%B8%E0%A4%82%E0%A4%9A%E0%A4%AF%E0%A4%A8%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%B8%E0%A4%AA%E0%A4%A8%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%87%20-%20%E0%A4%B8%E0%A5%87%20%E0%A4%A6%E0%A4%BF%E0%A4%A8%20%28%20%E0%A4%97%E0%A5%81%E0%A4%B0%E0%A4%A6%E0%A4%AF%E0%A4%BE%E0%A4%B2%20%E0%A4%B8%E0%A4%BF%E0%A4%82%E0%A4%B9%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%B8%E0%A4%82%E0%A4%9A%E0%A4%AF%E0%A4%A8%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%202%20%E0%A4%B8%E0%A4%AA%E0%A4%A8%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%87%20-%20%E0%A4%B8%E0%A5%87%20%E0%A4%A6%E0%A4%BF%E0%A4%A8%20%28%20%E0%A4%97%E0%A5%81%E0%A4%B0%E0%A4%A6%E0%A4%AF%E0%A4%BE%E0%A4%B2%20%E0%A4%B8%E0%A4%BF%E0%A4%82%E0%A4%B9%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  },
  {
    "name": "भाग 2 पाठ 3 टोपी शुक्ला ( राही मासूम रज़ा ) Crash Course  Class 10th Hindi",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/4208224%E0%A4%B8%E0%A4%82%E0%A4%9A%E0%A4%AF%E0%A4%A8%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%9F%E0%A5%8B%E0%A4%AA%E0%A5%80%20%E0%A4%B6%E0%A5%81%E0%A4%95%E0%A5%8D%E0%A4%B2%E0%A4%BE%20%28%20%E0%A4%B0%E0%A4%BE%E0%A4%B9%E0%A5%80%20%E0%A4%AE%E0%A4%BE%E0%A4%B8%E0%A5%82%E0%A4%AE%20%E0%A4%B0%E0%A4%9C%E0%A4%BC%E0%A4%BE%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf_%E0%A4%B8%E0%A4%82%E0%A4%9A%E0%A4%AF%E0%A4%A8%20%E0%A4%AD%E0%A4%BE%E0%A4%97%202%20%E0%A4%AA%E0%A4%BE%E0%A4%A0%203%20%E0%A4%9F%E0%A5%8B%E0%A4%AA%E0%A5%80%20%E0%A4%B6%E0%A5%81%E0%A4%95%E0%A5%8D%E0%A4%B2%E0%A4%BE%20%28%20%E0%A4%B0%E0%A4%BE%E0%A4%B9%E0%A5%80%20%E0%A4%AE%E0%A4%BE%E0%A4%B8%E0%A5%82%E0%A4%AE%20%E0%A4%B0%E0%A4%9C%E0%A4%BC%E0%A4%BE%20%29%20Crash%20Course%20%20Class%2010th%20Hindi.pdf"
  }
]
    },
    It:{
      0:[
  {
    "name": "Communication Skills Chapter 1 Methods of Communication Crash Course Class 10th",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4252130/1733830190_2081930975394159/sunny/1733825074280_106866008856111710_video_VOD.m3u8"
  },
  {
    "name": "Communication Skills Chapter 2 Communication Cycle Crash Course Class 10th",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4252128/1733829820_7214557874992040/sunny/1733823755507_10887074772321714_video_VOD.m3u8"
  },
  {
    "name": "Unit 1 ~ Communication Skills Chapter 3 ~ Communication Cycle Crash Course Class 10th",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4252129/1733830001_7288596206762465/sunny/1733824403682_218136090563478720_video_VOD.m3u8"
  },
  {
    "name": "syllabus overview information technology",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253519/1733939349_9836424075319562/sunny/1733922893649_606381648465615100_video_VOD.m3u8"
  },
  {
    "name": "Unit 1 ~ Communication Skills Chapter 4",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4253526/1733939899_4001080925440579/sunny/1733923297982_719786810994531600_video_VOD.m3u8"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 6 Stress Management and its Techniques",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269171/1735287304_5805174019823514/sunny/1735284925900_37132218530430410_video_VOD.m3u8"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 7 Ability to work Independently.",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269170/1735287124_7015449337947726/sunny/1735284855412_423526993822563460_video_VOD.m3u8"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 8 Operating System",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269168/1735285936_2765513123421494/sunny/1735284792898_804471840566281600_video_VOD.m3u8"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 9 Managing Files and Folder",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269169/1735286584_5575402676491602/sunny/1735284824301_163133305163695300_video_VOD.m3u8"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 10 Care and the management of Computer",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4269172/1735287965_8582953084308447/sunny/1735284972511_709245772175792600_video_VOD.m3u8"
  },
  {
    "name": "BASIC WRITING SKILLS Chapter 5",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4273940/1735994764_7473797843440754/sunny/1735990997686_113120161658737860_video_VOD.m3u8"
  },
  {
    "name": "Unit 4 - Entrepreneurial Skills Chapter 11 Entrepreneur and Entrepreneurship",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4273942/1735995484_3526316728111531/sunny/1735991429913_288196611621510180_video_VOD.m3u8"
  },
  {
    "name": "Unit 5 Green Skills Chapter 12 Sustainable Development",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4273941/1735994885_6909588962676846/sunny/1735991228066_761144511854995000_video_VOD.m3u8"
  },
  {
    "name": "Unit 1 DIGITAL DOCUMENTATION (ADVANCED) Chapter 1 APPLYING STYLES IN A DOCUMENT.",
    "m3u8Url": "https://d3cx6qbbd4cbso.cloudfront.net/file_library/videos/vod_non_drm_ios/4273976/1735997946_2766391625244738/sunny/1735994322618_12651719687063890_video_VOD.m3u8"
  },
  {
    "name": "Part B Most Important MCQs",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/4283105/173703498382831097666/173703498382831097666_1097666.m3u8"
  }
],
      1:[
  {
    "name": "Unit 1 - Communication Skills Chapter 1 Methods of Communication Crash Course",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/455539340100537660.pdf"
  },
  {
    "name": "Unit 1- Communication Skills Chapter 2 Communication Cycle Crash Course",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540admin_v1/file_manager/pdf/819693362227044200.pdf"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 3 Communication Barriers",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/6900322Unit%202-%20Communication%20Skills%20Chapter%203%20Communication%20Barriers.pdf_Unit%202-%20Communication%20Skills%20Chapter%203%20Communication%20Barriers.pdf"
  },
  {
    "name": "Unit 1 - Communication Skills Chapter 1 Methods of Communication Crash Course Class 10th Information Technology",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/7407159Unit%201%20-%20Communication%20Skills%20Chapter%201%20Methods%20of%20Communication%20Crash%20Course%20Class%2010th%20Information%20Technology.pdf_Unit%201%20-%20Communication%20Skills%20Chapter%201%20Methods%20of%20Communication%20Crash%20Course%20Class%2010th%20Information%20Technology.pdf"
  },
  {
    "name": "Unit 1- Communication Skills Chapter 2 Communication Cycle Crash Course Class 10th Information Technology",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/6155395Unit%201-%20Communication%20Skills%20Chapter%202%20Communication%20Cycle%20Crash%20Course%20Class%2010th%20Information%20Technology.pdf_Unit%201-%20Communication%20Skills%20Chapter%202%20Communication%20Cycle%20Crash%20Course%20Class%2010th%20Information%20Technology.pdf"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 4 Effective Communication",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/6228673Unit%202-%20Communication%20Skills%20Chapter%204%20Effective%20Communication.pdf_Unit%202-%20Communication%20Skills%20Chapter%204%20Effective%20Communication.pdf"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 9 Managing Files and Folder",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2169311Unit%202-%20Communication%20Skills%20Chapter%209%20Managing%20Files%20and%20Folder.pdf_Unit%202-%20Communication%20Skills%20Chapter%209%20Managing%20Files%20and%20Folder.pdf"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 8 Operating System",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/1610177Unit%202-%20Communication%20Skills%20Chapter%208%20Operating%20System%27.pdf_Unit%202-%20Communication%20Skills%20Chapter%208%20Operating%20System%27.pdf"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 7 Ability to work Independently",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/5401143Unit%202-%20Communication%20Skills%20Chapter%207%20Ability%20to%20work%20Independently.pdf_Unit%202-%20Communication%20Skills%20Chapter%207%20Ability%20to%20work%20Independently.pdf"
  },
  {
    "name": "Unit 2- Communication Skills Chapter 6 Stress Management and its Techniques",
    "redirect": "https://dxixtlyravvxx.cloudfront.net/540/admin_v1/file_manager/pdf/2173417Unit%202-%20Communication%20Skills%20Chapter%206%20Stress%20Management%20and%20its%20Techniques.pdf_Unit%202-%20Communication%20Skills%20Chapter%206%20Stress%20Management%20and%20its%20Techniques.pdf"
  }
],
    },
  };
  const handleLectureClick = (lecture) => {
    if (lecture.youtubeUrl) {
      window.location.href = lecture.youtubeUrl;
    }
  };

  return (
    <div className="chapter-lectures-container">
      <img src={mlogo} alt="Logo" className="big-logo" />
      <h2>{subject} - Chapter {parseInt(chapterIndex) + 1}</h2>
      <div className="lecture-boxes">
        {chapterLectures[subject]?.[chapterIndex]?.map((lecture, index) => {
          if (lecture.redirect) {
            return (
              <div
                key={index}
                onClick={() => window.location.href = lecture.redirect}
                className="lecture-box"
                style={{ cursor: "pointer" }}
              >
                {lecture.name} (PDF)
              </div>
            );
          } else if (lecture.youtubeUrl) {
            return (
              <div
                key={index}
                onClick={() => handleLectureClick(lecture)}
                className="lecture-box"
                style={{ cursor: "pointer" }}
              >
                {lecture.name} (YouTube)
              </div>
            );
          } else if (lecture.m3u8Url) {
            return (
              <Link
                key={index}
                to={`/video/${subject}/${chapterIndex}`}
                state={{
                  chapterName: lecture.name,
                  m3u8Url: lecture.m3u8Url,
                  notesUrl: lecture.notesUrl,
                }}
                className="lecture-box"
                onClick={() => {
              // Store chapter name and index in localStorage for later use
              localStorage.setItem("lectureName", lecture.name);  // Store chapter name
            }}
              >
                {lecture.name}
              </Link>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default ChapterLectures10;
